export const environment = {
    production: '%ENV_PRODUCTION%',
    apiURL: '%ENV_APIURL%',
    s3_url: '%ENV_S3_URL%'
};
